import React, { FC, ReactElement, useContext, useMemo } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardBody,
  CardFooter,
  Carousel,
  Paragraph,
  ResponsiveContext,
  Text,
} from 'grommet';
import { Subheading } from '@/components/Subheading';
import { Star, StarHalf } from 'grommet-icons';
import { Testimony } from '@/types';
import { testimonies } from '@/data';

const Review: FC<{ value: number }> = ({ value }): ReactElement => (
  <Box direction="row">
    {Array.from(Array(Math.floor(value)).keys()).map((index) => (
      <Star key={index} color="plain" size="small" />
    ))}
    {value - Math.floor(value) >= 0.5 ? (
      <StarHalf color="plain" size="small" />
    ) : null}
  </Box>
);

const TestimonyCard: FC<Testimony> = ({
  review,
  title,
  description,
  avatarURL,
  author,
  authorPosition,
}): ReactElement => (
  <Card
    elevation="xlarge"
    background="background-contrast"
    width="medium"
    height="medium"
    margin={{ horizontal: `small`, vertical: `xlarge` }}
  >
    <CardBody pad="medium">
      <Review value={review} />
      <Text weight="bold" margin={{ top: `small` }}>
        {title}
      </Text>
      <Paragraph>{description}</Paragraph>
    </CardBody>
    <CardFooter
      justify="start"
      background={{ light: `light-1`, dark: `dark-3` }}
      pad={{ horizontal: `large`, vertical: `medium` }}
    >
      <Avatar src={avatarURL} />
      <Box>
        <Text weight="bold">{author}</Text>
        <Text>{authorPosition}</Text>
      </Box>
    </CardFooter>
  </Card>
);

const CarouselPage: FC<any> = ({ page, pageSize }): ReactElement => (
  <Box direction="row" gap="medium" align="center" justify="center">
    {testimonies
      .slice(page * pageSize, page * pageSize + pageSize)
      .map((testimony, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <TestimonyCard key={index} {...testimony} />
      ))}
  </Box>
);

const screenSizeCardsMap = {
  small: 1,
  medium: 2,
  large: 3,
};

export const ClientTestimony: FC = (): ReactElement => {
  const size = useContext(ResponsiveContext);
  const cardsPerSlide = useMemo(() => screenSizeCardsMap[size], [size]);
  return (
    <Box align="center" gap="small">
      <Subheading textAlign="center">
        A+ RATED PENETRATION TESTING SERVICES
      </Subheading>
      <Text size="xxlarge" weight="bold" textAlign="center">
        Recent Testimonials
      </Text>
      <Carousel wrap fill>
        {Array.from(
          Array(Math.floor(testimonies.length / cardsPerSlide)).keys(),
        ).map((index) => (
          <CarouselPage key={index} page={index} pageSize={cardsPerSlide} />
        ))}
      </Carousel>
    </Box>
  );
};
